import { loadScript } from '@paypal/paypal-js';

const getConfig = (root, kind = 'config') => {
    const selector = `script[data-kind="${kind}"][type="application/json"]`;
    return [...root.querySelectorAll(selector)].map((script) => JSON.parse(script.textContent));
};

Alpine.data('SevenPaymentPaypalClient', (element) => ({
    isSupported: false,
    config: getConfig(element).at(-1),

    model: {},

    async init() {
        const components = {
            'paypal-capture': ['buttons'],
            'paypal-applePay': 'applepay',
            'paypal-creditCard': 'card-fields',
        };

        const fundingSources = {
            'paypal-venmo': 'venmo',
        };

        if (window.location.hostname.includes('ddev.site')) {
            this.config.buyerCountry = 'US';
        }

        const clientConfig = (this.config.paymentProcessors ?? []).reduce((acc, pp) => {
            return components[pp.type] ? {
                ...acc,
                clientId: pp.properties?.clientId ?? acc.clientId,
                // merchantId: pp.properties?.merchantId ?? acc.merchantId,
                components: [...acc.components, components[pp.type]],
            } : acc;
        }, {
            'debug': false,
            'enable-funding': (this.config.paymentProcessors ?? []).map((pp) => fundingSources[pp.type]).filter(Boolean),
            'intent': this.config.intent,
            'locale': this.config.locale,
            'currency': this.config.currency,
            ...this.config.buyerCountry ? { 'buyer-country': this.config.buyerCountry } : {},
            'integration-date': '2023-10-31',
            'components': [],
        });

        const paypal = await loadScript(clientConfig);
        this._dispatchEvent('init', {
            paypal,
            createOrder: async (paymentProcessor, productIdentifier) => {
                const order = await new Promise((resolve) => {
                    const payment = {
                        ...this.model,
                        ...(productIdentifier ? { basket: [productIdentifier] } : {})
                    };

                    if (this._dispatchEvent(`createorder`, {
                        payment,
                        createPayment: (payment) => resolve(payment),
                    })) {
                        // event has not been cancelled, so we can resolve the promise automatically
                        resolve(payment);
                    }
                });

                const res = await fetch('/api/checkout/createOrderAndPayment', {
                    method: 'POST',
                    body: JSON.stringify({ order, paymentProcessor }),
                    headers: { 'Content-Type': 'application/json' },
                });

                return await res.json();
            },
        });
    },

    _dispatchEvent(name, { cancelable, bubbles, ...detail } = {}) {
        return element.dispatchEvent(new CustomEvent(`seven:payment:paypal:client:${name}`, {
            detail,
            bubbles: bubbles ?? true,
            cancelable: cancelable ?? true,
        }));
    },

}));


